import React from "react";
import { BaseFilterProps } from "../../lib";
import { ClientMultiselect } from "../ClientMultiselect/ClientMultiselect";

/** Org-level Tasks filter: limits tasks to the selected clients (workspaces). */
export const TaskClientFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <ClientMultiselect
        name="taskClient"
        clientIds={filters.taskClientIds}
        onClientIdsChange={(taskClientIds) => onChange({ taskClientIds })}
    />
);
